export default "__VITE_ASSET__BdKW9jVf__"